// extracted by mini-css-extract-plugin
export default {"tabFeatureSwitch":"tabFeatureSwitch--uHnmh","label":"label--Vkw9v","switchBtn":"switchBtn--ykr8A","switchBtnChecked":"switchBtnChecked--sIkjd","switchHandle":"switchHandle--JNHbX"};